// Screen widths listed here should match media query screen width in the CSS variables file: /Solution/Project/DDX/Dimensional.DDX.Web/WebSource/src/components/base/partials/_variables.scss

export const SCREEN_WIDTHS = Object.freeze({
	MIN: 360,
	XS: 767,
	SM: 1023,
	MD: 1439,
	LG: 1440
});
